export const chatMessageData = [
    {
        user_name: "Alexandra Della",
        user_img: "/images/avatar/1.png",
        time: "10:32 PM",
        isReplay: false,
        messages: [
            "Hi,",
            "How are you?"
        ]
    },

    {
        user_name: "Green Cute",
        user_img: "/images/avatar/2.png",
        time: "10:35 PM",
        isReplay: true,
        messages: [
            "Hello Alex!!! Welcome to Live Chat!!!",
            "My name is Green & How can I help you today???"
        ]
    },

    {
        user_name: "Alexandra Della",
        user_img: "/images/avatar/1.png",
        time: "10:40 PM",
        isReplay: false,
        messages: [
            "Hi, I wanted to check my order status....",
            "My order number is <a href='#'>#NXL0458</a>"
        ]
    },

    {
        user_name: "Green Cute",
        user_img: "/images/avatar/2.png",
        time: "10:42 PM",
        isReplay: true,
        messages: [
            "No problem, let me check that for you.",
            "Thanks for the information!!! Give me one moment please while I check on that for you.",
            "Thanks for your times, Your order <a href='#'>#NXL0458</a> will arive on this weekend."
        ]
    },

    {
        user_name: "Alexandra Della",
        user_img: "/images/avatar/1.png",
        time: "10:45 PM",
        isReplay: false,
        messages: [
            "Thanks. I'm worried😳 it won't arrive in time⌚ for my daughter's birthday🎂 party🎉 this weekend.",
            "Order tracking number is: <a href='#'>#698745</a>"
        ]
    },

    {
        user_name: "Green Cute",
        user_img: "/images/avatar/2.png",
        time: "10:48 PM",
        isReplay: true,
        messages: [
            "I understand your concern… I wouldn't want my child's gift to arrive late either.",
            "It looks like your order is set to arrive in 2 business days, so it should arrive by Friday, just in time!",
            {
                "fileUrl": [
                    {
                        iconSrc: "/images/file-icons/zip.png",
                        fileName: "Order.zip",
                        fileSize: "402.65/KB"
                    },
                    {
                        iconSrc: "/images/file-icons/png.png",
                        fileName: "Document.png",
                        fileSize: "480.14/KB"
                    },
                    {
                        iconSrc: "/images/file-icons/psd.png",
                        fileName: "Photos.psd",
                        fileSize: "248.54/KB"
                    },
                ]
            }
        ]
    },

    {
        user_name: "Alexandra Della",
        user_img: "/images/avatar/1.png",
        time: "10:50 PM",
        isReplay: false,
        messages: [
            "The birthday🎂 ceremony preparation almost completed",
            "Thank your so much.....!!!!"
        ]
    },

    {
        user_name: "Green Cute",
        user_img: "/images/avatar/2.png",
        time: "10:42 PM",
        isReplay: true,
        messages: [
            "I understand your concern......!!",
            "Anything else can I help you???",
        ]
    },

    {
        user_name: "Alexandra Della",
        user_img: "/images/avatar/1.png",
        time: "10:50 PM",
        isReplay: false,
        isTyping: true,
        messages: []
    },

]